export default "__VITE_ASSET__DB2Q5o1z__"